module.exports = __webpack_public_path__ + "static/img/装饰11.8be256a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰11.svg
// module id = jip9
// module chunks = 2